import { render, staticRenderFns } from "./LowerThirdProperty.vue?vue&type=template&id=164e9d02&"
import script from "./LowerThirdProperty.vue?vue&type=script&lang=js&"
export * from "./LowerThirdProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports